import { render } from "./SideNavbar.vue?vue&type=template&id=cf963720&scoped=true"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"

import "./SideNavbar.vue?vue&type=style&index=0&id=cf963720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf963720"]])

export default __exports__